import React from 'react';
import { Box, Container, Grid, Link, Typography, IconButton, TextField, Button } from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import InstagramIcon from '@mui/icons-material/Instagram';

// Import your logo from its actual path
import logo from "../../Assets/Images/Image.jpeg"

// --- Data for the links ---
const quickLinks = [
    { label: 'Home', href: '/' },
    { label: 'About Us', href: '/about' },
    { label: 'Services', href: '/services' },
    { label: 'Contact', href: '/contact' },
];

const resources = [
    { label: 'Privacy Policy', href: '/privacy' },
    { label: 'Terms of Service', href: '/terms' },
    { label: 'FAQ', href: '/faq' },
    { label: 'Blog', href: '/blog' },
];

const socialLinks = [
    { icon: <FacebookIcon />, url: '#', label: 'Facebook' },
    { icon: <TwitterIcon />, url: '#', label: 'Twitter' },
    { icon: <LinkedInIcon />, url: '#', label: 'LinkedIn' },
    { icon: <InstagramIcon />, url: '#', label: 'Instagram' },
];

// --- The Main Component ---
const Footer = () => {
    return (
        <Box
            component="footer"
            sx={{
                backgroundColor: '#f4f6f8',
                color: 'text.secondary',
                py: { xs: 4, md: 6 },
                mt: 8,
                borderTop: '1px solid',
                borderColor: 'divider',
            }}
        >
            <Container maxWidth="lg">
                <Grid container spacing={4}>

                    {/* --- Column 1: Brand Info & Socials --- */}
                    <Grid item xs={12} md={4}>
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                            <img src={logo} alt="Vediverse Logo" style={{ height: 40, width: 40, marginRight: 12, borderRadius: "50%" }} />
                            <Typography variant="h6" sx={{ fontWeight: 'bold', color: 'text.primary' }}>
                                Vediverse
                            </Typography>
                        </Box>
                        <Typography variant="body2" sx={{ mb: 2 }}>
                            A modern digital platform for futuristic web solutions. Empowering innovation with creativity and technology.
                        </Typography>
                        <Box>
                            {socialLinks.map((social) => (
                                <IconButton key={social.label} component="a" href={social.url} target="_blank" aria-label={social.label} sx={{ color: 'text.secondary', '&:hover': { color: 'primary.main' } }}>
                                    {social.icon}
                                </IconButton>
                            ))}
                        </Box>
                    </Grid>

                    {/* --- Column 2 & 3: Quick Links & Resources --- */}
                    <Grid item xs={6} md={2}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: 'text.primary', mb: 2 }}>
                            Quick Links
                        </Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                            {quickLinks.map((link) => (
                                <Link key={link.label} href={link.href} color="inherit" underline="hover" sx={{ mb: 1 }}>
                                    {link.label}
                                </Link>
                            ))}
                        </Box>
                    </Grid>

                    <Grid item xs={6} md={2}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: 'text.primary', mb: 2 }}>
                            Resources
                        </Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                            {resources.map((link) => (
                                <Link key={link.label} href={link.href} color="inherit" underline="hover" sx={{ mb: 1 }}>
                                    {link.label}
                                </Link>
                            ))}
                        </Box>
                    </Grid>

                    {/* --- Column 4: Newsletter Signup --- */}
                    <Grid item xs={12} md={4}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: 'text.primary', mb: 2 }}>
                            Subscribe to our Newsletter
                        </Typography>
                        <Typography variant="body2" sx={{ mb: 2 }}>
                            Get the latest updates on new products and upcoming sales.
                        </Typography>
                        <Box component="form" sx={{ display: 'flex', gap: 1 }}>
                            <TextField
                                variant="outlined"
                                size="small"
                                placeholder="Your email address"
                                fullWidth
                                sx={{ backgroundColor: 'white' }}
                            />
                            <Button variant="contained" type="submit">
                                Subscribe
                            </Button>
                        </Box>
                    </Grid>

                </Grid>

                {/* --- Bottom Copyright Bar --- */}
                <Box sx={{ textAlign: 'center', mt: 4, pt: 3, borderTop: '1px solid', borderColor: 'divider' }}>
                    <Typography variant="body2">
                        © {new Date().getFullYear()} Vediverse. All Rights Reserved.
                    </Typography>
                </Box>
            </Container>
        </Box>
    );
};

export default Footer;